var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogodocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3859 1.8934L2.45541 9.65924C1.55242 10.2016 1 11.1777 1 12.2311V27.7959C1 28.906 1.61302 29.9254 2.59357 30.4458L17.3532 38.2794C18.3418 38.8041 19.5402 38.7349 20.4618 38.0998L32.7022 29.6653C33.5148 29.1054 34 28.1817 34 27.195V12.2969C34 11.2083 33.4103 10.2051 32.4591 9.67561L18.3896 1.84395C17.4516 1.32184 16.3061 1.3407 15.3859 1.8934Z",
    stroke: "#ED583B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5332 19.2988C11.596 19.2925 12.6567 19.282 13.7195 19.282C17.0418 19.2799 20.3641 19.282 23.6864 19.282H24.2986V20.6041H23.7757C19.5415 20.6041 15.3052 20.6041 11.071 20.6041C10.8924 20.6041 10.7139 20.6167 10.5332 20.623V19.2988Z",
    fill: "#ED583B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5332 27.2251C10.7118 27.2314 10.8903 27.2439 11.071 27.2439C15.2924 27.2439 19.5118 27.2439 23.7332 27.2439H24.3305C24.3305 27.6595 24.3432 28.0372 24.3199 28.4128C24.3156 28.4842 24.1817 28.5765 24.0903 28.6038C23.9819 28.6374 23.8544 28.6122 23.7332 28.6122C19.5118 28.6122 15.2924 28.6122 11.071 28.6122C10.8924 28.6122 10.7139 28.6269 10.5353 28.6353C10.5353 28.1652 10.5353 27.693 10.5353 27.223L10.5332 27.2251Z",
    fill: "#ED583B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5332 11.2667C10.7266 11.2793 10.9179 11.3024 11.1114 11.3024C15.3328 11.3024 19.5521 11.3108 23.7736 11.294C24.2327 11.294 24.3985 11.4136 24.339 11.8606C24.3071 12.104 24.3326 12.3559 24.3326 12.6811H10.5332V11.2667Z",
    fill: "#ED583B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogodocument);
export default __webpack_public_path__ + "static/media/logodocument.3e34c75a5c298f74220972f870a6294d.svg";
export { ForwardRef as ReactComponent };